export default __webpack_public_path__ + "static/media/sc6.9009cf62.png";